import React from "react";
export default function PatronageConditions() {
  return;
}